var initialState = {
  current: null,
  error: null
};
export default initialState;